import { Dialog } from "@headlessui/react";
import React from "react";
import Button from "../../../components/ui/Button";
import { lastNine } from "../employeeProductionHelpers";
import { ReceivingItem } from "../employeeProductionTypes";

type Props = {
  item: ReceivingItem;
  onEdit: (item: ReceivingItem) => void;
  onDelete: (item: ReceivingItem) => void;
};

export function ScannedItemActionsDialog({ item, onEdit, onDelete }: Props) {
  return (
    <div>
      <Dialog.Title className="mt-3 text-center text-medium font-bold leading-6 text-gray-900 sm:mt-5">
        Barcode: {lastNine(item.barcode)}
      </Dialog.Title>
      <p className="mt-4 text-center text-sm font-semibold text-gray-600">
        Amount Used: {item.ingredient_amount_used} {item.unit_of_measure ?? ""}
      </p>
      <div className="mt-5 grid grid-cols-2 gap-2 sm:mt-6">
        <Button fullWidth onClick={() => onEdit(item)}>
          Edit
        </Button>
        <Button variant="danger" fullWidth onClick={() => onDelete(item)}>
          Delete
        </Button>
      </div>
    </div>
  );
}
